import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Web API is crucial for Adobe Commerce and Magento Open Source because of the need to integrate with order management, customer management, and other enterprise management software systems.`}</p>
    <p>{`There are many headless Adobe Commerce and Magento Open Source installations in which a merchant partially uses native functionality while the other pieces of an eCommerce website are provided by other systems.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      